module.exports = __webpack_public_path__ + "static/media/ico_external.db2d6968.svg";